/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoadChainageDto } from '../../models/load-chainage-dto';

export interface CreateLoadChainage$Params {
      body: LoadChainageDto
}

export function createLoadChainage(http: HttpClient, rootUrl: string, params: CreateLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadChainageDto>> {
  const rb = new RequestBuilder(rootUrl, createLoadChainage.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadChainageDto>;
    })
  );
}

createLoadChainage.PATH = '/v1/loadchainages';
